<template>
    <div class="d-flex align-items-center justify-content-center">
        <loader position="static" size="30" class="block-loader"></loader>
    </div>
</template>

<script>
  export default {
    name: "BlockLoader"
  }
</script>

<style scoped lang="scss">
    .block-loader {
        margin-top: 2.5rem;
    }
</style>
